import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { ContactDictionaryControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useContactDictionaryArchive = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new ContactDictionaryControllerApi(
      getConfigObject()
    ).updateContactDictionaryArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID
    )
  );
